const getDefaultScrollConfig = (passive: boolean = true) => ({
  passive,
});

export default getDefaultScrollConfig;
